import { Link } from 'react-router-dom';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      {/* Header */}
      <header className="py-6 px-6 border-b border-gray-800">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer">
            <img src="/logo.png" alt="Kuze Logo" className="h-10 w-auto" />
          </Link>
          <Link to="/" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 cursor-pointer">
            <i className="ri-arrow-left-line"></i>
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-normal">Terms of Service</h1>
          <p className="text-gray-400 mb-12">Last updated: February 2025</p>

          <div className="space-y-10 text-gray-300">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4 leading-normal">1. Acceptance of Terms</h2>
              <p className="leading-relaxed mb-4">
                These Terms of Service ("Terms") govern your use of the Kuze mobile application ("Kuze", "the App") operated by Think Heart Co. AB ("we", "our", "us").
              </p>
              <p className="leading-relaxed mb-4">
                By downloading or using Kuze, you agree to these Terms.
              </p>
              <p className="leading-relaxed">
                If you do not agree, do not use the App.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4 leading-normal">2. Eligibility</h2>
              <p className="leading-relaxed mb-4">
                Kuze is intended for users aged 18 and older.
              </p>
              <p className="leading-relaxed">
                By using Kuze, you confirm that you are at least 18 years old.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4 leading-normal">3. Nature of the App</h2>
              <p className="leading-relaxed mb-4">
                Kuze is a real-time multiplayer party game designed for entertainment purposes.
              </p>
              <p className="leading-relaxed mb-4">
                Gameplay may include:
              </p>
              <ul className="list-disc list-inside space-y-2 mb-4 ml-4">
                <li>Voting</li>
                <li>Social prompts</li>
                <li>Competitive mechanics</li>
                <li>Humor and adult-themed content</li>
              </ul>
              <p className="leading-relaxed">
                You understand that content may be provocative, competitive, or socially sensitive. You use the App at your own discretion.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4 leading-normal">4. User Conduct</h2>
              <p className="leading-relaxed mb-4">
                You agree not to:
              </p>
              <ul className="list-disc list-inside space-y-2 mb-4 ml-4">
                <li>Use illegal, hateful, threatening, or discriminatory display names</li>
                <li>Harass or abuse other players</li>
                <li>Attempt to disrupt live sessions</li>
                <li>Exploit bugs or manipulate game mechanics</li>
                <li>Reverse engineer, decompile, or copy the App</li>
                <li>Use automated systems or bots</li>
                <li>Misuse referral or invite systems</li>
              </ul>
              <p className="leading-relaxed">
                We reserve the right to restrict or block access to users who violate these Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4 leading-normal">5. In-App Purchases</h2>
              <p className="leading-relaxed mb-4">
                Kuze offers optional in-app purchases.
              </p>
              <p className="leading-relaxed mb-4">
                Payments are processed exclusively by:
              </p>
              <ul className="list-disc list-inside space-y-2 mb-4 ml-4">
                <li>Apple App Store</li>
                <li>Google Play Store</li>
              </ul>
              <p className="leading-relaxed mb-4">
                We do not process payments directly.
              </p>
              <p className="leading-relaxed mb-4">
                All purchases are:
              </p>
              <ul className="list-disc list-inside space-y-2 mb-4 ml-4">
                <li>Final, except where required by applicable law</li>
                <li>Non-transferable</li>
                <li>Licensed, not sold</li>
              </ul>
              <p className="leading-relaxed mb-4">
                Refund requests must be handled through the respective platform provider.
              </p>
              <p className="leading-relaxed">
                We reserve the right to modify pricing or available content at any time.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4 leading-normal">6. Intellectual Property</h2>
              <p className="leading-relaxed mb-4">
                All content in Kuze, including but not limited to:
              </p>
              <ul className="list-disc list-inside space-y-2 mb-4 ml-4">
                <li>Game concepts</li>
                <li>Text</li>
                <li>Graphics</li>
                <li>Logos</li>
                <li>Branding</li>
                <li>Software code</li>
              </ul>
              <p className="leading-relaxed mb-4">
                is owned by or licensed to Think Heart Co. AB.
              </p>
              <p className="leading-relaxed">
                You may not copy, reproduce, distribute, or create derivative works without written permission.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4 leading-normal">7. User-Generated Content</h2>
              <p className="leading-relaxed mb-4">
                Display names, gameplay inputs, and shared content are created by users.
              </p>
              <p className="leading-relaxed mb-4">
                We do not pre-screen content.
              </p>
              <p className="leading-relaxed mb-4">
                You are solely responsible for any content you enter or share.
              </p>
              <p className="leading-relaxed">
                We reserve the right to remove content or restrict access if necessary.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4 leading-normal">8. Social Sharing</h2>
              <p className="leading-relaxed mb-4">
                Kuze may allow sharing of links, results, or game content.
              </p>
              <p className="leading-relaxed mb-4">
                You are responsible for what you choose to share.
              </p>
              <p className="leading-relaxed">
                We are not responsible for how third-party platforms handle shared content.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4 leading-normal">9. Disclaimer of Warranties</h2>
              <p className="leading-relaxed mb-4">
                Kuze is provided "as is" and "as available."
              </p>
              <p className="leading-relaxed mb-4">
                We do not guarantee:
              </p>
              <ul className="list-disc list-inside space-y-2 mb-4 ml-4">
                <li>Continuous availability</li>
                <li>Error-free operation</li>
                <li>That the App will meet all expectations</li>
              </ul>
              <p className="leading-relaxed">
                Use is at your own risk.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4 leading-normal">10. Limitation of Liability</h2>
              <p className="leading-relaxed mb-4">
                To the maximum extent permitted by law, Think Heart Co. AB shall not be liable for:
              </p>
              <ul className="list-disc list-inside space-y-2 mb-4 ml-4">
                <li>Indirect or consequential damages</li>
                <li>Emotional distress from gameplay</li>
                <li>User-generated content</li>
                <li>Loss of data</li>
                <li>Loss of profits</li>
              </ul>
              <p className="leading-relaxed">
                Our total liability shall not exceed the amount you paid for in-app purchases in the previous 12 months.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4 leading-normal">11. Termination</h2>
              <p className="leading-relaxed mb-4">
                We may suspend or terminate access to Kuze at any time if you violate these Terms.
              </p>
              <p className="leading-relaxed">
                You may stop using the App at any time by uninstalling it.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4 leading-normal">12. Changes to the App</h2>
              <p className="leading-relaxed mb-4">
                We may:
              </p>
              <ul className="list-disc list-inside space-y-2 mb-4 ml-4">
                <li>Modify or remove features</li>
                <li>Add or remove game content</li>
                <li>Update mechanics</li>
                <li>Discontinue the App</li>
              </ul>
              <p className="leading-relaxed">
                without prior notice.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4 leading-normal">13. Governing Law</h2>
              <p className="leading-relaxed mb-4">
                These Terms are governed by the laws of Sweden.
              </p>
              <p className="leading-relaxed">
                Any disputes shall be subject to the exclusive jurisdiction of Swedish courts, unless otherwise required by applicable consumer protection laws.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4 leading-normal">14. Contact</h2>
              <div className="bg-gray-800/50 rounded-xl p-6">
                <p className="mb-2"><strong className="text-white">Company:</strong> Think Heart Co. AB</p>
                <p><strong className="text-white">Email:</strong> hello@thinkheart.co</p>
              </div>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 px-6 border-t border-gray-800">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">© 2026 Kuze. Built for real-life parties.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">Privacy</Link>
            <Link to="/terms" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">Terms</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
